import { BlogConfig } from './config.types';

export function getBlogConfig(): BlogConfig | undefined {
  if (!process.env.BLOG_CONFIG) {
    console.error('env.BLOG_CONFIG is missing!');

    return;
  }
  return JSON.parse(process.env.BLOG_CONFIG) as BlogConfig;
}
